import { Table } from '@octano/global-ui';
import { useGetPaymentStatusTranslation } from '../hooks/useGetPaymentStatusTranslation';
import { useTitulationPaymentColumns } from '../hooks/useTitulationPaymentColumns';
import { TitulationPaymentInfo } from '../types';

type Props = {
  titulationPaymentInfo: TitulationPaymentInfo;
  texts: {
    title: string;
    paymentStatuses: {
      pending: string;
      paid: string;
    };
    table: {
      headers: {
        concept: string;
        amount: string;
        paymentDate: string;
        status: string;
        action: string;
      };
      values: {
        concept: string;
        button: string;
      };
    };
  };
};

export function TitulationPaymentSection({
  titulationPaymentInfo,
  texts,
}: Props) {
  const columns = useTitulationPaymentColumns(texts);
  return (
    <>
      <h2 className="fs-20 fw-600 text-primary text-uppercase mb-4">
        {texts.title}
      </h2>
      <Table
        columns={columns}
        data={[
          {
            ...titulationPaymentInfo,
            status: useGetPaymentStatusTranslation(
              titulationPaymentInfo.status,
            ),
          },
        ]}
      />
    </>
  );
}
